export const WELCOME_TO_KNOCKOUT_DIALOG = 'WelcomeToKnockoutDialog';

export const NO_KNOCKOUT_DIALOG = 'NO_KNOCKOUT_DIALOG';
